<template>
	<div class="xs-12 md-4 md-pr2">
		<j-card class="bg5 c6 pt4">
			<div class="xs-12 ta2 fs10 fw7 c1">{{ count }}</div>
			<div class="xs-12 ta2 mb4">{{ title }}</div>
			<div class="xs-12 flex xs-center p4 bt1 bc7">
				<slot name="bottom"></slot>
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"

export default {
	components: {
		JCard,
		JButton,
		CrmIcon
	},
	props: {
		count: [Number, String],
		title: String
	}
}
</script>
